import * as _ from "lodash-es";
import ControlArrow from "../../public/carousel_control_arrow.svg";
import {Dispatch, SetStateAction} from "react";
import {FCWithHTMLAttributes} from "../types/reactTypes";

interface CarouselControlsProps {
	numPages: number;
	page: number | null;
	setPage: Dispatch<SetStateAction<number | null>>; // useState hook setter
}

const CarouselControls: FCWithHTMLAttributes<CarouselControlsProps> = ({
	numPages,
	page,
	setPage,
	className,
}) => {
	const onClickLeft = () => setPage((p) => Math.max((p ?? 0) - 1, 0));
	const onClickRight = () =>
		setPage((p) => Math.min((p ?? 0) + 1, numPages - 1));
	return (
		<div className={`flex items-center gap-4 ${className}`}>
			<button onClick={onClickLeft}>
				<ControlArrow className="w-9 cursor-pointer fill-rich-orange" />
			</button>
			{_.times(numPages, (i) => (
				// Outer div with padding makes the button easier to click
				<div key={i} className="cursor-pointer p-1" onClick={() => setPage(i)}>
					<div
						className={`h-2 w-2 rounded-full ${
							page === i ? "bg-rich-orange" : "bg-gray-600"
						}`}
					/>
				</div>
			))}
			<button onClick={onClickRight}>
				<ControlArrow className="w-9 rotate-180 cursor-pointer fill-rich-orange" />
			</button>
		</div>
	);
};

export default CarouselControls;
